// extracted by mini-css-extract-plugin
export var bgImage = "styles-module--bg-image--ec4c8";
export var imageContentSection = "styles-module--image-content-section--07d77";